import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import strings from "../i18n/language";
import React, { useState } from "react";
import CustomTextField from "../form/CustomTextField";
import CustomSelectField from "../form/CustomSelectField";
import CustomDateField from "../form/CustomDateField";
import { toast } from "react-toastify";
import {
  Typography,
  IconButton,
  Button,
  Box,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import AutoFixNormalIcon from "@mui/icons-material/AutoFixNormal";

import {
  createPaymentAction,
  deletePaymentAction,
} from "../redux/actions/payment";
import dayjs from "dayjs";

const SubscriptionPayments = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const subscription = useSelector((state) => state.subscription.subscription);
  const [date, setDate] = useState(null);
  const [amount, setAmount] = useState(null);
  const [type, setType] = useState("transferencia");
  const [currency, setCurrency] = useState("BOL");
  const [comment, setComment] = useState(null);
  const [module, setModule] = useState("Servital");
  const user = useSelector((state) => state.user.user);

  if (!subscription?.Payments) return null;
  else
    return (
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          {strings.TITLE_PAYMENTS_SUBSCRIPTION} #{subscription.id}
        </DialogTitle>
        <DialogContent>
          {user.type !== "viewer" && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 2,
                mt: 1,
              }}
            >
              <IconButton
                onClick={() => {
                  setDate(dayjs(new Date()));
                }}
              >
                <AutoFixNormalIcon />
              </IconButton>
              <CustomDateField
                value={date}
                required
                onChange={setDate}
                isValid={!!date}
                label={strings.LABEL_DATE}
              />
              <CustomTextField
                required
                variant="filled"
                id="amount"
                label={strings.LABEL_AMOUNT}
                name="amount"
                autoComplete="off"
                onChange={setAmount}
                value={amount}
              />
              <CustomSelectField
                onChange={setCurrency}
                required
                title={strings.LABEL_CURRENCY}
                id={"currency"}
                value={currency}
                defaultValues={[
                  { value: "USD", label: "USD" },
                  { value: "BOL", label: "BOL" },
                ]}
                defaultValue={"BOL"}
              />
              <CustomSelectField
                onChange={setType}
                title={strings.LABEL_TYPE}
                required
                id={"type"}
                value={type}
                defaultValues={[
                  { value: "efectivo", label: strings.LABEL_CASH },
                  { value: "transferencia", label: strings.LABEL_TRANSFER },
                  { value: "pago_movil", label: strings.LABEL_MOBILE_PAYMENT },
                ]}
                defaultValue={"efectivo"}
              />
              <CustomSelectField
                onChange={setModule}
                title="Módulo"
                required
                id={"module"}
                value={module}
                defaultValues={[
                  { value: "Servital", label: "Servital" },
                  { value: "Laboral", label: "Laboral" },
                ]}
                defaultValue={"Servital"}
              />
              <CustomTextField
                variant="filled"
                id="comment"
                label={strings.LABEL_COMMENT}
                name="comment"
                autoComplete="off"
                onChange={setComment}
                value={comment}
              />
              <IconButton
                onClick={() => {
                  if (!date || !amount)
                    toast.error(strings.ERROR_DATE_OR_AMOUNT);
                  else {
                    dispatch(
                      createPaymentAction({
                        type: type,
                        currency: currency,
                        amount: amount,
                        date: date,
                        comment: comment,
                        module: module,
                        subscription_id: subscription.id,
                      })
                    );
                  }
                }}
              >
                <AddIcon />
              </IconButton>
            </Box>
          )}
          {subscription.Payments.length === 0 ? (
            <Typography sx={{ textAlign: "center", py: 2 }}>
              {strings.MESSAGE_NO_PAYMENTS}
            </Typography>
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{strings.LABEL_DATE}</TableCell>
                    <TableCell align="right">{strings.LABEL_AMOUNT}</TableCell>
                    <TableCell>{strings.LABEL_CURRENCY}</TableCell>
                    <TableCell>{strings.LABEL_TYPE}</TableCell>
                    <TableCell>Módulo</TableCell>
                    <TableCell>{strings.LABEL_COMMENT}</TableCell>
                    {user.type !== "viewer" && (
                      <TableCell align="right">
                        {strings.LABEL_ACTION}
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subscription.Payments.map((payment) => (
                    <TableRow key={payment.id}>
                      <TableCell>
                        {dayjs(payment.date).format("L")}
                      </TableCell>
                      <TableCell align="right">{payment.amount}</TableCell>
                      <TableCell>{payment.currency}</TableCell>
                      <TableCell>
                        {payment.type === "efectivo"
                          ? strings.LABEL_CASH
                          : payment.type === "transferencia"
                          ? strings.LABEL_TRANSFER
                          : payment.type === "pago_movil"
                          ? strings.LABEL_MOBILE_PAYMENT
                          : payment.type}
                      </TableCell>
                      <TableCell>{payment.module || "Servital"}</TableCell>
                      <TableCell>{payment.comment}</TableCell>
                      {user.type !== "viewer" && (
                        <TableCell align="right">
                          <IconButton
                            onClick={() => {
                              dispatch(deletePaymentAction(payment.id));
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            {strings.BUTTON_CLOSE}
          </Button>
        </DialogActions>
      </Dialog>
    );
};

export default SubscriptionPayments;
